module.exports = __webpack_public_path__ + "img/total.32a0ab62.svg";